import { AcroNode } from "./types";
import { escapeHtml } from "./escapeHtml";

export function renderGroupOptionRow(groupNode: AcroNode): string {
  const title = groupNode.title ? `<div class="text-sm text-gray-700">${escapeHtml(String(groupNode.title))}</div>` : "";
  const fieldId = groupNode.field_id ? escapeHtml(String(groupNode.field_id)) : "";
  const options = (groupNode.options ?? []) as unknown[];
  const fieldIdAttr = fieldId ? ` data-field-id="${fieldId}"` : "";
  const optsHtml = options.map((opt, i) => `
    <label class="flex items-center gap-2 py-1">
      <input type="checkbox" data-id="${escapeHtml(String(groupNode.id ?? ""))}__opt_${i}"${fieldIdAttr} class="form-checkbox" />
      <span class="text-sm">${escapeHtml(String(opt))}</span>
    </label>
  `).join("");
  return `<div class="py-2">${title}${optsHtml}</div>`;
}
